module.exports = __webpack_public_path__ + "img/aiahrn-logo.fdd79e81.png";